module.exports = __webpack_public_path__ + "static/media/tabIcon.9179049f.png";